module.exports = __webpack_public_path__ + "img/21.5c66bfe4.jpg";